import axios from 'axios';

// Request Interceptor to add Authorization token
export const setAxiosInterceptors = (token) => {
    axios.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  // Response Interceptor to handle token expiration
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.log(error)
      if (error.response && error.response.status === 401) {
      
        // Token expired or unauthorized access, clear all user data
        localStorage.removeItem('token');
        localStorage.removeItem('entityLanguage');
        localStorage.removeItem('currentPath');
        
        if (window.location.pathname !== '/') {
          // Force complete page reload to clear any cached state
          window.location.href = '/';
        }
      }
      return Promise.reject(error);
    }
  );
}
  




